import React from "react";
import { Link } from "react-router-dom";
import './TileCard.css';

export default function TopTile({ iconClass, label, value, to, subtitle, loading }) {
  return (
    <div className="col-12 col-md-6 col-xl-3">
      <div className="card tile-card mb-3">
        <div className="card-body d-flex align-items-start">
          <i className={`${iconClass} tile-icon me-3`} /> {/* space between icon & text */}
          <div>
            <div className="tile-label text-muted mb-1" style={{marginLeft:'15px'}}>{label}</div>   {/* space below label */}
            <div className="tile-value" style={{marginLeft:'15px'}}>
              {to ? (
                <Link to={to} className="text-muted">
                  {subtitle || (loading ? "…" : value)}
                </Link>
              ) : (
                <span className="text-muted">{loading ? "…" : value}</span>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
